import * as actionTypes from "../action-types";

export const getDashboard = payload => ({ type: actionTypes.GET_DASHBOARD, payload });
export const setDashboard = payload => ({ type: actionTypes.SET_DASHBOARD, payload });

export const getRecentActivity = payload => ({ type: actionTypes.GET_RECENT_ACTIVITY, payload });
export const setRecentActivity = payload => ({ type: actionTypes.SET_RECENT_ACTIVITY, payload });